export const accountSetup = {
  payments: {
    planUnavailableTitle: "Não disponível no seu plano",
    planUnavailableMessage:
      "Os pagamentos dos hóspedes via Stripe estão disponíveis apenas nos planos Standard e superiores. Faça upgrade do seu plano para ativar este recurso e começar a receber pagamentos diretamente, sem intermediários.",
  },
  modalConnection: {
    header: "Conectar um PMS",
    loaderMessage: "Salvando, aguarde.",
    selectPmsLabel: "Selecione um sistema PMS",
    selectPmsPlaceholder: "Selecione um PMS",
    apiKeyLabel: "API Key do {pms}",
    apiKeyPlaceholder: "Digite sua API Key",
    cancel: "Cancelar",
    save: "Salvar conexão",
    fieldRequired: "Campo obrigatório",
    selectPmsError: "Selecione um PMS",
    apiKeyError: "Digite a API Key",
    savedTitle: "Conexão salva",
    savedMessage: "A conexão foi salva com sucesso",
    saveFailMessage: "Não foi possível salvar a conexão",
    errorTitle: "Erro",
    serverError: "Erro ao conectar ao servidor",
  },
  subscription: {
    title: "Minha assinatura",
    subtitle: "Veja e gerencie seu plano, forma de pagamento e faturamento.",
    statusActive: "Ativa",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Cancelada · ativa até",
    validUntil: "Ativa até:",
    statusPaymentPending: "Pagamento pendente",
    statusTrial: "Período de teste",
    statusNone: "Sem assinatura ativa",
    intervalYearly: "Plano anual",
    intervalMonthly: "Plano mensal",
    perMonthShort: "/mês",
    nextRenewal: "Próxima renovação:",
    servicesIncluded: "Serviços incluídos",
    units: "unidade | unidades",
    perUnitSuffix: "/unidade",
    serviceFallback: "Serviço",
    manageOpening: "Abrindo…",
    manageButton: "Gerenciar assinatura e faturas",
    emptyText:
      "Você ainda não tem um plano ativo. Escolha um para começar a receber check-ins e pagamentos.",
    buyPlan: "Comprar um plano",
    types: {
      apartment: "Apartamento",
      hotel: "Hotel",
      room: "Quarto",
      camping: "Camping",
      villa: "Villa",
      chatbot: "Recepção com IA",
    },
  },
  purchased: {
    title: "Disponível na sua assinatura",
    subtitle: "Cota contratada e uso atual",
    accommodations: "Acomodações",
    empty: "Você ainda não criou nenhuma acomodação.",
    createProperty: "Criar propriedade",
    adjust: "Ajustar",
    loadError: "Não foi possível carregar as informações.",
    labels: {
      apartment: "Apartamento(s)",
      hotel: "Hotel (Quartos)",
      hotelPack: "Hotel (Quartos) · #{id}",
      villa: "Villas",
      camping: "Campings",
      campingPack: "Campings · #{id}",
      chatbot: "Licenças de chatbot",
    },
    units: {
      unid: "unidades",
      room: "quartos",
      spots: "vagas",
      licenses: "licenças",
    },
    types: {
      hotel: "Hotel",
      camping: "Camping",
      villa: "Villa",
      apartment: "Apartamento",
    },
    badge: {
      rooms: "{n} quartos",
      spots: "{n} vagas",
      unit: "1 unidade",
    },
  },
  notifications: {
    title: "Notificações",
    description: "Ative ou desative as automações de mensagens e os alertas.",
    loading: "Carregando configurações...",
    alwaysActive: "Sempre ativo",
    active: "Ativado",
    inactive: "Desativado",
    hint:
      "Observação: algumas automações são mostradas como informativas porque já fazem parte do fluxo padrão do sistema.",
    loadError: "Não foi possível carregar as configurações.",
    saveError: "Não foi possível salvar a alteração. Tentando novamente...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Confirmação de reserva (WhatsApp)",
        description:
          "Envia automaticamente o modelo de confirmação quando uma reserva é confirmada.",
      },
      email_checkin_sent: {
        title: "Notificações por e-mail quando o check-in é enviado",
        description:
          "Envia um e-mail automático quando o processo de check-in é concluído ou enviado.",
      },
      whatsapp_checkin_link_auto: {
        title: "Enviar WhatsApp automático para check-in online",
        description:
          "Envia automaticamente o link do check-in online via WhatsApp quando aplicável.",
      },
      checkin_link_send_policy: {
        title: "Política de envio do link de check-in para reservas diretas",
        description:
          "Defina se o link é sempre enviado ou apenas quando a reserva está paga ou parcialmente paga.",
        options: {
          always: {
            label: "Sempre enviar",
            description:
              "Envia o link de check-in independentemente do status de pagamento.",
          },
          paid_or_partially_paid: {
            label: "Apenas paga ou parcialmente paga",
            description:
              "Envia o link apenas se a reserva estiver totalmente ou parcialmente paga. Aplica-se somente a reservas diretas.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Colômbia",
    statusVerified: "Conectado",
    statusPending: "Não verificado",
    publicKeyLabel: "Chave pública",
    privateKeyLabel: "Chave privada",
    keepPrivateLabel: "Manter a chave privada salva (oculta por segurança)",
    privatePlaceholderSaved: "•••••••••••• (salva)",
    btnDisconnect: "Desconectar",
    btnVerify: "Verificar conta",
    btnSave: "Salvar credenciais",
    merchantHeader: "Comerciante detectado",
    missingPublicKey: "Chave pública ausente",
    missingPrivateKey: "Chave privada ausente",
    savedOk: "Credenciais salvas com sucesso",
    saveError: "Erro ao salvar as credenciais",
    verifiedOk: "Conta verificada",
    notVerified: "Conta não verificada",
    verifyError: "Erro ao verificar a conta",
    disconnectConfirm: "Tem certeza de que deseja desconectar o Wompi deste negócio?",
    disconnectedOk: "Desconectado com sucesso",
    disconnectError: "Erro ao desconectar",
  },
  pricelabs: {
    subtitle: "Otimização dinâmica de preços",
    statusConnected: "Conectado",
    statusDisconnected: "Não conectado",
    loading: "Carregando configurações...",
    emailLabel: "E-mail do PriceLabs",
    emailPlaceholder: "your-email@pricelabs.com",
    importantTitle: "Importante:",
    bullet1: "Certifique-se de que suas propriedades estão totalmente configuradas",
    bullet2: "Escolhe que anúncios vão para a PriceLabs",
    bullet3:
      "Os preços serão atualizados de acordo com o PriceLabs e não podem ser editados manualmente pela Wacheckin",
    btnConnect: "Conectar e sincronizar",
    btnConnecting: "Conectando...",
    btnSync: "Sincronizar",
    btnSyncing: "Sincronizando...",
    btnDisconnect: "Desconectar",
    btnDisconnecting: "Desconectando...",
    emailRequired: "Digite o seu e-mail do PriceLabs",
    emailRequiredTitle: "E-mail obrigatório",
    connectHeader: "Conectar com o PriceLabs?",
    connectMessage:
      "Todas as suas propriedades e quartos ativos serão vinculados. Tarifas e disponibilidade serão sincronizadas. Qualquer propriedade/quarto criado depois será enviado automaticamente.",
    connectAccept: "Sim, conectar",
    cancel: "Cancelar",
    linkError: "Erro ao vincular as unidades",
    emailNotFoundConnect:
      "O PriceLabs informou que o e-mail não existe. Verifique seu e-mail e tente novamente.",
    emailInvalidTitle: "E-mail do PriceLabs inválido",
    syncSuccess: "Suas propriedades agora estão conectadas ao PriceLabs.",
    syncSuccessTitle: "Sincronização concluída!",
    syncFail: "Não foi possível concluir a sincronização",
    errorTitle: "Erro",
    emailNotFoundManual:
      "O PriceLabs indicou que o e-mail não existe. Corrija o e-mail e sincronize novamente.",
    manualSuccess: "O processo foi concluído com sucesso.",
    manualSuccessTitle: "Sincronização manual",
    manualFail: "Não foi possível sincronizar com o PriceLabs",
    rejected: "A PriceLabs rejeitou {count} anúncio(s). {detail}",
    rejectedTitle: "Não foi possível sincronizar",
    nothingSent: "Nenhum anúncio foi enviado. Verifica se os escolhidos têm preço e moeda.",
    relinked: "{count} anúncio(s) continuavam ligados a outra conta PriceLabs: foram enviados com um novo identificador, por isso aparecem lá como novos.",
    relinkedTitle: "Novo identificador",
    syncedAt: "Sincronizado · {when}",
    notSyncedYet: "Ligado, por enviar",
    noneSelected: "Não escolheste nenhum alojamento. Marca os que queres na PriceLabs e sincroniza outra vez.",
    disconnectHeader: "Desconectar o PriceLabs?",
    disconnectMessage: "Todas as suas propriedades serão desvinculadas do PriceLabs.",
    disconnectAccept: "Sim, desconectar",
    disconnectedOk: "Sua conta foi desconectada do PriceLabs",
    disconnectedTitle: "Desconectado",
    disconnectFail: "Não foi possível desconectar do PriceLabs",
    noErrorsReported: "Nenhum erro reportado.",
    listingPrefix: "Anúncio {id}: ",
    unknownError: "Erro desconhecido",
    listTitle: "Quais anúncios vão para o PriceLabs",
    listHint: "Escolha quais o PriceLabs deve gerir. Os que deixar desligados mantêm os seus preços e é você quem os edita.",
    listCount: "{n} de {total} escolhidos",
    listSearch: "Procurar um alojamento ou um quarto…",
    listRooms: "{n} quartos",
    listApartment: "Apartamento",
    listEmpty: "Ainda não tem alojamentos.",
    listNoMatch: "Nenhum alojamento com esse nome.",
    listNeedsCurrency: "Falta a moeda",
    listNeedsRate: "Falta uma tarifa",
    btnConnectN: "Ligar e sincronizar | Ligar e sincronizar {n} | Ligar e sincronizar {n}",
    unitConnected: "{name} já vai para o PriceLabs",
    unitDisconnected: "{name} já não vai para o PriceLabs",
    unitFail: "Não foi possível alterar. Tente novamente.",
    listLocked: "Ligue a sua conta PriceLabs e poderá escolher aqui quais anúncios gere.",
    listAll: "Todos",
    listNone: "Nenhum",
    btnSyncN: "Sincronizar | Sincronizar 1 anúncio | Sincronizar {n} anúncios",
    connectedOk: "Conta ligada. Agora escolha quais anúncios vão para o PriceLabs.",
    connectedTitle: "Pronto",
  },
};